// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-workshop-js": require("gatsby-module-loader?name=component---src-templates-workshop-js!/app/src/templates/workshop.js"),
  "component---src-pages-404-jsx": require("gatsby-module-loader?name=component---src-pages-404-jsx!/app/src/pages/404.jsx"),
  "component---src-pages-index-jsx": require("gatsby-module-loader?name=component---src-pages-index-jsx!/app/src/pages/index.jsx"),
  "component---src-pages-schedule-jsx": require("gatsby-module-loader?name=component---src-pages-schedule-jsx!/app/src/pages/schedule.jsx"),
  "component---src-pages-speakers-jsx": require("gatsby-module-loader?name=component---src-pages-speakers-jsx!/app/src/pages/speakers.jsx")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/app/.cache/json/layout-index.json"),
  "design-is-a-job.json": require("gatsby-module-loader?name=path---design-is-a-job!/app/.cache/json/design-is-a-job.json"),
  "css-in-2018.json": require("gatsby-module-loader?name=path---css-in-2018!/app/.cache/json/css-in-2018.json"),
  "smart-responsive-interface-design-patterns.json": require("gatsby-module-loader?name=path---smart-responsive-interface-design-patterns!/app/.cache/json/smart-responsive-interface-design-patterns.json"),
  "designing-for-delight.json": require("gatsby-module-loader?name=path---designing-for-delight!/app/.cache/json/designing-for-delight.json"),
  "designing-calm-technology.json": require("gatsby-module-loader?name=path---designing-calm-technology!/app/.cache/json/designing-calm-technology.json"),
  "jobs-to-be-done-for-better-product-strategy.json": require("gatsby-module-loader?name=path---jobs-to-be-done-for-better-product-strategy!/app/.cache/json/jobs-to-be-done-for-better-product-strategy.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/app/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/app/.cache/json/index.json"),
  "schedule.json": require("gatsby-module-loader?name=path---schedule!/app/.cache/json/schedule.json"),
  "speakers.json": require("gatsby-module-loader?name=path---speakers!/app/.cache/json/speakers.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/app/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/app/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js